import React, { useState } from 'react'
import './Stats.scss'
import { useStatsEditor } from '../../Components/Stats/statEditor/useStatsEditor'
import { ActionBar } from '../../Components/Stats/statEditor/action-bar/action-bar'
import { StatRow } from '../../Components/Stats/stat-row/stat-row'
import { StatPreview } from '../../Components/Stats/stat-preview/stat-preview'
import { HorizontalLoader, ModalWrapper } from 'Components'

function Stats() {
  const editor = useStatsEditor()
  const [isDiscardOpen, setIsDiscardOpen] = useState(false)


  if (editor.status === 'error') {
    return (
      <div className='Stats-editor__state' role='alert'>
        Couldn&apos;t load Impact content.
        <button type='button' className='Stats-editor__retry' onClick={() => void editor.reload()}>
          Try again
        </button>
      </div>
    )
  }

  const handleDiscardConfirm = () => {
    setIsDiscardOpen(false)
    editor.discard()
  }

  return (
    <div className='Stats'>
      <div className='container mt-4'>
        <div className='container'>
          <div className='card border-0'>
            <div className='card-header border-0 px-0 pb-4'>
              <div className='row d-flex align-items-end'>
                <div className='col-12 col-md-6 col-lg-8 my-auto'>
                  <div className='title'>Numbers that tell our story</div>
                  <div className='sub-title'>
                    Edit the stats shown on the TradeGrid landing page. Changes stay as a draft
                    until you publish.
                  </div>
                </div>
                <div className='col-12 col-md-6 col-lg-4 pt-3 pt-md-0 d-flex justify-content-end text-end'>
                  <ActionBar
                    isDirty={editor.isDirty}
                    isPublishing={editor.isPublishing}
                    onDiscard={() => setIsDiscardOpen(true)}
                    onPublish={() => void editor.publish()}
                  />
                </div>
              </div>
            </div>

            {editor.status === 'loading' ? (
              <div className='text-center'>
                <HorizontalLoader />
              </div>
            ) : (
              <div className='Stats-editor__layout'>
                <div className='Stats-editor__main'>
                  <ol className='Stats-editor__list'>
                    {editor.items.map((item: any, index: any) => (
                      <StatRow
                        key={item.id}
                        item={item}
                        index={index}
                        total={editor.items.length}
                        isEditing={editor.editingId === item.id}
                        showErrors={editor.validatedIds.includes(item.id)}
                        onEdit={editor.startEdit}
                        onDone={editor.finishEdit}
                        onChange={editor.changeField}
                        onBlur={editor.blurField}
                        onMove={editor.moveItem}
                        onToggleVisibility={editor.toggleVisibility}
                      />
                    ))}
                  </ol>
                </div>

                <div className='Stats-editor__aside'>
                  <StatPreview items={editor.items} editingId={editor.editingId} />
                </div>
              </div>
            )}

            <p className='visually-hidden' aria-live='polite'>
              {editor.announcement}
            </p>

            <ModalWrapper
              showModal={isDiscardOpen}
              closeModal={() => setIsDiscardOpen(false)}
              title='Discard unpublished changes?'
              hideHeader={false}
            >
              <p className='Stats-editor__confirm-message'>
                Your edits, reordering and hidden stats will be reverted to what is currently live.
                This can’t be undone.
              </p>
              <div className='Stats-editor__confirm-actions'>
                <button
                  type='button'
                  className='Stats-editor__confirm-btn'
                  onClick={() => setIsDiscardOpen(false)}
                >
                  Keep editing
                </button>
                <button
                  type='button'
                  className='Stats-editor__confirm-btn Stats-editor__confirm-btn--danger'
                  onClick={handleDiscardConfirm}
                >
                  Discard changes
                </button>
              </div>
            </ModalWrapper>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Stats
